import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { KeycloakService } from 'keycloak-angular';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from './app/auth/token';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from './app/app.config';
import { initializeApp } from './app/bootstrap/flutter';
import { initializeKeycloak } from './app/bootstrap/keycloak.bootstrap';
import { DEFAULT_LANG } from './app/services/language';

const isFlutter = typeof globalThis.window !== 'undefined' && (globalThis.window as any).isFlutterWebView === true &&
  typeof (globalThis.window as any).flutter_token_value === 'string';

if (isFlutter) {
  // Aguardar inicialização ANTES de bootstrapear o Angular
  await initializeApp();
  await new Promise(resolve => setTimeout(resolve, 500));
}




bootstrapApplication(App, {
  providers: [
    //garantir que a aplicação de máscara funcione no formulário
    provideEnvironmentNgxMask(),

    //REGISTRA O SERVICE
    KeycloakService,

    //ROTAS
    provideRouter(routes),

    // HTTP + INTERCEPTOR
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor])
    ),

    //INICIALIZA KEYCLOAK
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },

    // responsável pela tradução
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: DEFAULT_LANG,
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ]
});

